<template>
  <div class="gradient-background">
    <slot></slot>
  </div>
</template>

<script>
  export default {};
</script>

<style lang="scss" scoped>
  $color: #4c00a4;
  $lightColor: lighten($color, 15);
  $darkColor: darken($color, 15);

  .gradient-background {
    position: absolute;
    width: 100%;
    height: 100%;
    background: $color;
  }
</style>
